<template>
  <v-card>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template #activator="{ on }">
        <v-text-field
          v-model="form.dateFrom"
          label="日付"
          prepend-icon="event"
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="form.dateFrom"
        :max="maxDate"
        @input="menu = false"
      />
    </v-menu>
    <!-- <v-menu
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template #activator="{ on }">
        <v-text-field
          v-model="form.dateTo"
          label="日付"
          prepend-icon="event"
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="form.dateTo"
        :max="maxDate"
        @input="menu2 = false"
      />
    </v-menu> -->
    <v-card-actions>
      <v-spacer />
      <v-btn color="error" :disabled="!downloading" @click="abort = true">
        中断
      </v-btn>
      <v-btn
        color="primary"
        :disabled="!form.dateFrom"
        :loading="downloading"
        @click="getCSV"
      >
        出力
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment'
const DATA_PROPS = [
  { text: '予約店舗コード', prop: 'shopCode' },
  { text: '予約店舗名称', prop: 'shopName' },
  {
    text: '予約登録日時',
    prop: 'registered',
    transform: v => moment(v).format('YYYY-MM-DD HH:mm'), // NOTE: JSTで日時は返してるはず
  },
  { text: '来店予定日', prop: 'date' },
  { text: '来店予定時間', prop: 'time' },
  { text: '予約ステータス', prop: 'state' },
  { text: '予約経路', prop: 'reservingWay' },
  { text: '予約対応スタッフコード', prop: 'attendedStaffCode' },
  { text: '予約対応スタッフ名', prop: 'attendedStaffName' },
  { text: '予約者セイ', prop: 'reserverFamilyNameKana' },
  { text: '予約者メイ', prop: 'reserverGivenNameKana' },
  { text: '顧客番号', prop: 'customerNumber' },
  { text: '顧客セイ', prop: 'customerFamilyNameKana' },
  { text: '顧客メイ', prop: 'customerGivenNameKana' },
]
export default {
  name: 'KPIDaily',
  data: () => ({
    form: {
      dateFrom: moment()
        .subtract(1, 'days')
        .format('YYYY-MM-DD'),
      // dateTo: null,
    },
    menu: false,
    // menu2: false,
    downloading: false,
    abort: false,
  }),
  computed: {
    maxDate() {
      return moment().format('YYYY-MM-DD')
    },
  },
  methods: {
    async getCSV() {
      try {
        this.downloading = true
        let date = this.form.dateFrom
        let rows = await this.request([DATA_PROPS.map(x => x.text)])
        if (this.abort) {
          this.$toast.info('中断しました。')
        } else if (rows.length <= 1) {
          // NOTE: ヘッダで1行は必ずある
          this.$toast.error('データがありませんでした。')
        } else {
          this.dl(`kpi-daily-${date}.csv`, rows)
        }
      } catch (err) {
        console.error(err)
        this.$toast.error('エラーが発生しました。')
      }
      this.downloading = false
      this.abort = false
    },
    async request(r, url = null) {
      let { results, next } = await (url
        ? this.$api.http.get(url)
        : this.$api.kpis.staff(this.form.dateFrom))
      if (this.abort) return
      results = results.map(data =>
        DATA_PROPS.map(x => this.transform(data, x))
      )
      r = r.concat(results)
      if (next) return await this.request(r, next)
      else return r
    },
    transform(data, { prop, transform }) {
      let rval = data[prop] || ''
      if (transform) {
        rval = transform(rval)
      }
      return `"${rval}"`
    },
    dl(filename, rows) {
      rows = rows.map(row => row.join(','))
      let content = rows.join('\r\n')
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let blob = new Blob([bom, content], { type: 'text/csv' })

      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filename)
      } else {
        let a = document.createElement('a')
        a.download = filename
        // a.target = '_blank'
        a.href = window.URL.createObjectURL(blob)

        // firefox対策． chromeの場合は append/remove をしなくていいらしい
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    },
  },
}
</script>
